import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import MuiTypography from '@mui/material/Typography';
import { styled } from '@mui/material';
import OverflowWindow from '../../OverflowWindow/OverflowWindow.js';
import '../../OverflowWindow/OverflowProvider.js';
import '../../OverflowWindow/components/MenuCategory.js';
import '../../OverflowWindow/components/ChecklistItems.js';
import MenuItem from '../../OverflowWindow/components/MenuItem.js';
import '../../OverflowWindow/components/SubMenuItem.js';
import 'react';
import '../../OverflowWindow/components/CascadingProvider.js';
import Hint from '../../Hint/Hint.js';

const _OverflowWindow = styled(OverflowWindow) `
  .MuiMenu-paper {
    max-height: 136px;
  }
`;
const EllipsisMenu = ({ menuItems, onItemClick, hint }) => {
    return (jsx(_OverflowWindow, Object.assign({ dense: true, target: jsx(Hint, Object.assign({ title: hint }, { children: jsx(MuiTypography, Object.assign({ variant: "h5", "data-testid": "breadcrumb-menu-target" }, { children: "..." })) })), "data-testid": "breadcrumb-menu" }, { children: menuItems.map((_a) => {
            var { index } = _a, item = __rest(_a, ["index"]);
            return (jsx(MenuItem, Object.assign({ onClick: () => onItemClick(item, index), hint: item.hint, "data-testid": `menu-breadcrumb-${item.id}` }, { children: item.label }), item.id));
        }) })));
};

export { EllipsisMenu as default };
//# sourceMappingURL=EllipsisMenu.js.map
